import React, { Component } from 'react';
import { Grid, Row, Col, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ContentWrapper from '../../Layout/ContentWrapper';

import { fetchSalesPerformanceData } from './utils';

import CategorySidebar from './components/CategorySidebar';
import SalesPerformanceGraph from './components/SalesPerformanceGraph';
import Spinner from '../../Widgets/spinner';
import { companyCodeTitle } from '../../../actions/root_url';

class CategoryAnalysis extends Component {
  constructor() {
    super();
    this.state = {
      // category side bar
      expandedCategoryId: -1,

      // sales performace graph
      activeCategoryName: 'All',
      activeGroupId: null,
      activeCategoryId: null,
      salesPerformanceDateFilter: 'weekly',
      salesPerformanceDataIsLoading: false,
      salesPerformanceData: null,
      salesPerformanceDataError: null,
    };

    this.handleExpandGroup = this.handleExpandGroup.bind(this);
    this.handleCategoryClick = this.handleCategoryClick.bind(this);
    this.handleChangeSalesPerformanceDateFilter = this.handleChangeSalesPerformanceDateFilter.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
  }

  componentWillMount() {
    this.props.fetchGroups();
    this.handleFetchSalesPerformanceData();
  }

  handleFetchSalesPerformanceData() {
    this.setState({
      salesPerformanceDataIsLoading: true,
      salesPerformanceDataError: null,
    });
    fetchSalesPerformanceData(this.state.salesPerformanceDateFilter, this.state.activeGroupId, this.state.activeCategoryId)
      .then((response) => {
        this.setState({
          salesPerformanceDataIsLoading: false,
          salesPerformanceData: response.data,
          salesPerformanceDataError: null,
        });
      }, (err) => {
        this.setState({
          salesPerformanceDataIsLoading: false,
          salesPerformanceDataError: err,
        });
      });
  }

  handleChangeSalesPerformanceDateFilter(type) {
    if (type === 'weekly' || type === 'monthly') {
      this.setState({
        salesPerformanceDateFilter: type,
      }, () => {
        this.handleFetchSalesPerformanceData();
      });
    }
  }

  handleCategoryClick(name, groupId = null, categoryId = null) {
    this.setState({
      activeCategoryName: name,
      activeGroupId: groupId,
      activeCategoryId: categoryId,
    }, () => {
      this.handleFetchSalesPerformanceData();
    });
  }

  handleExpandGroup(id) {
    this.setState({
      expandedCategoryId: id,
    });
    this.props.fetchGroupCategories(id);
  }

  createSalesObject() {
    return {
      labels: [],
      datasets: [
        {
          label: 'Total Cost',
          backgroundColor: 'rgba(255,99,132,0.6)',
          borderColor: 'rgba(255,99,133,1)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,133,0.8)',
          hoverBorderColor: 'rgba(255,99,133,1)',
          data: [],
        },
        {
          label: 'Total Sales',
          backgroundColor: 'rgba(20, 92, 169, 0.4)',
          borderColor: 'rgba(20, 92, 169, 1)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(20, 92, 169, 0.6)',
          hoverBorderColor: 'rgba(20, 92, 169, 1)',
          data: [],
        },
      ],
    };
  }

  cleanSalesPerformanceData() {
    const months = [0, 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const salesTotals = this.createSalesObject();
    this.state.salesPerformanceData.forEach((record) => {
      if (this.state.salesPerformanceDateFilter === 'monthly') {
        salesTotals.labels.push(months[record.Month]);
      } else {
        salesTotals.labels.push(record.Day);
      }

      salesTotals.datasets[0].data.push(record.TotalCost);
      salesTotals.datasets[1].data.push(record.TotalSales);
    });
    return salesTotals;
  }

  render() {
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="category_analysis" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid>
          <Row>
            <Col xs={2}>
              <CategorySidebar
                categories={this.props.categories}
                subCategories={this.props.subCategories}
                expandedCategoryId={this.state.expandedCategoryId}
                handleExpandGroup={this.handleExpandGroup}
                handleCategoryClick={this.handleCategoryClick}
              />
            </Col>
            <Col xs={10}>
              {
                this.state.salesPerformanceDataIsLoading ?
                  <Spinner /> :
                  <SalesPerformanceGraph
                    salesPerformanceData={this.cleanSalesPerformanceData()}
                    activeCategoryName={this.state.activeCategoryName}
                    salesPerformanceDateFilterValue={this.state.salesPerformanceDateFilter}
                    handleChangeSalesPerformanceDateFilter={this.handleChangeSalesPerformanceDateFilter}
                  />
              }
            </Col>
          </Row>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default CategoryAnalysis;



// WEBPACK FOOTER //
// ./master/jsx/components/General/CategoryAnalysis/index.jsx